/* global axios */
import ApiClient from './ApiClient';

// Eltafouk: close-disposition report (سبب التواصل / النتيجة / تصنيف العميل recorded
// when agents resolve conversations). Accepts an ISO date range (since/until,
// Africa/Cairo) plus optional user_ids / inbox_ids / reason / outcome /
// classification filters.
class CloseDispositionReports extends ApiClient {
  constructor() {
    super('close_disposition_reports', { accountScoped: true });
  }

  fetch({
    since,
    until,
    userIds,
    inboxIds,
    reason,
    outcome,
    classification,
  } = {}) {
    const params = {};
    if (since) params.since = since;
    if (until) params.until = until;
    if (userIds && userIds.length) params.user_ids = userIds;
    if (inboxIds && inboxIds.length) params.inbox_ids = inboxIds;
    if (reason) params.reason = reason;
    if (outcome) params.outcome = outcome;
    if (classification) params.classification = classification;
    return axios.get(this.url, { params });
  }
}

export default new CloseDispositionReports();
